/**
 * StatusPill — inline-flex chip with a colored dot. Verbatim recipe:
 * height 24 (or 26), pad 0 10, radius full, tone-soft bg + tone-line border +
 * tone fg, 6px currentColor dot.
 */
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { fontFamily, fontSize, fontWeight, radii } from '../theme';

type Props = { label: string; tone: string; size?: 24 | 26; dot?: boolean };

export default function StatusPill({ label, tone, size = 24, dot = true }: Props) {
  const fg = `var(--${tone})`;
  return (
    <View
      style={[
        styles.pill,
        { height: size, borderColor: `var(--${tone}-line)`, backgroundColor: `var(--${tone}-soft)` } as any,
      ]}
    >
      {dot && <View style={[styles.dot, { backgroundColor: fg } as any]} />}
      <Text style={[styles.label, { color: fg } as any]}>{label}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  pill: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    paddingHorizontal: 10,
    borderRadius: radii.full,
    borderWidth: 1,
    alignSelf: 'flex-start',
  },
  dot: { width: 6, height: 6, borderRadius: 3 },
  label: { fontFamily: fontFamily.sans, fontSize: fontSize.xs, fontWeight: fontWeight.medium },
});
